import { Box, Typography } from '@material-ui/core'
import { StyledTopBarContainer } from './styles'

interface IDrawerTopBar {
  label: string
}

export const DrawerTopBar = ({ label }: IDrawerTopBar) => {
  return (
    <StyledTopBarContainer>
      <Box display="flex" justifyContent="center" alignItems="center" flexDirection="column">
        <Box
          className="top-bar"
          width="50px"
          height="3px"
          bgcolor={props => props.theme.colors.accent}
          borderRadius="8px"
          marginBottom="0.5rem"
        />
        <Typography variant="subtitle2">{label}</Typography>
      </Box>
    </StyledTopBarContainer>
  )
}
